// extracted by mini-css-extract-plugin
module.exports = {"SearchBox":"SearchBox-module--SearchBox--3jcg_","InputBox":"SearchBox-module--InputBox--1CUyj","search":"SearchBox-module--search--2q7fV"};